import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts'

const Chart = (props) => {
  const chartData = props.data;
  return <div>
    <h2 className="text-2xl mb-4">Tiktok, eBay and Amazon</h2>
    <div className="bg-gradient-to-br from-slate-900/70 to-slate-800/70 backdrop-blur-sm border border-slate-700/50 p-6 rounded-2xl">
      <ResponsiveContainer width="100%" height={350}>
        <BarChart data={chartData} margin={{ left: 20, top: 20, bottom: 20, right: 20 }}>
          <defs>
            <linearGradient id="cogsGradient" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#fb923c" stopOpacity={1} />
              <stop offset="100%" stopColor="#f97316" stopOpacity={0.2} />
            </linearGradient>
            <linearGradient id="profitGradient" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#a78bfa" stopOpacity={1} />
              <stop offset="100%" stopColor="#8b5cf6" stopOpacity={0.2} />
            </linearGradient>
            <linearGradient id="revenueGradient" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#f87171" stopOpacity={1} />
              <stop offset="100%" stopColor="#ef4444" stopOpacity={0.2} />
            </linearGradient>
          </defs>
          <CartesianGrid strokeDasharray="3 3" stroke="#334155" opacity={0.3} />
          <XAxis dataKey="name" stroke="#94a3b8" tick={{ fill: '#94a3b8' }} />
          <YAxis stroke="#94a3b8" tick={{ fill: '#94a3b8' }} />
          <Tooltip
            contentStyle={{
              backgroundColor: '#1e293b',
              border: '1px solid #334155',
              borderRadius: '12px',
              color: '#fff'
            }}
            itemSorter={() => 0}
          />
          <Legend
            wrapperStyle={{ paddingTop: '20px' }}
            iconType="circle"
          />
          <Bar dataKey="COGs" fill="url(#cogsGradient)" radius={[8, 8, 0, 0]} />
          <Bar dataKey="Profit" fill="url(#profitGradient)" radius={[8, 8, 0, 0]} />
          <Bar dataKey="Revenue" fill="url(#revenueGradient)" radius={[8, 8, 0, 0]} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  </div>
}

export default Chart;
